// extracted by mini-css-extract-plugin
export default {"root":"Table_root__n+ig0"};